import { roleToString, UserRole } from "utils/role";
import {
  IconContainer,
  Line,
  UserProfile,
  WorkspaceEmptyImageConainer,
  WorkspaceImageContainer,
  WorkspaceInfoContainer,
  WorkspaceItemContainer,
  WorkspaceProfile,
} from "./index.styles";
import UI from "@mile-meeting/mile-ui";

type WorkspaceItemProps = {
  workspaceName: string;
  role: number;
  workspaceImage?: string;
  onClick?: () => void;
};

const WorkspaceItem = (props: WorkspaceItemProps) => {
  const { workspaceName, role, workspaceImage, onClick } = props;
  return (
    <WorkspaceItemContainer onClick={onClick}>
      <WorkspaceInfoContainer>
        <WorkspaceProfile>
          {workspaceImage ? <WorkspaceImageContainer src={workspaceImage} /> : <WorkspaceEmptyImageConainer />}
          <UI.Typography type="headline01" fontStyle="medium" color="black" style={{width: "260px", display: "flex"}}>
            {workspaceName}
          </UI.Typography>
        </WorkspaceProfile>
        <Line />
        <UserProfile>
          <UI.Tag
            size="small"
            label={roleToString(role)}
            color="blue"
            type={role !== UserRole.Staff ? "secondary" : "primary"}
            styles={{
              container: {
                flex: 1,
              }
            }}
          />
        </UserProfile>
      </WorkspaceInfoContainer>
      <IconContainer>
        <UI.IconButton.Normal icon="arrowRight" color="var(--alias-color-label-normal)" badge={false} />
      </IconContainer>
    </WorkspaceItemContainer>
  );
};

export default WorkspaceItem;
